import { StrictMode } from 'react';

import ReactDOM from 'react-dom';

import { initDatadogLogs as initDataDogLogs, initDatadogRum } from 'src/utils/datadog';

import App from './App';
import AppProviders from './AppProviders';

initDataDogLogs();
initDatadogRum();

ReactDOM.render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
  document.getElementById('root')
);
